import React from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/styles';

import { paramConverter } from 'modules/common';
import { getFormat, twoDigits } from 'lib/commonLib';
import { mediaRoasStatistics } from 'lib/api/media';

import CurrentStatus from 'components/atoms/CurrentStatus';
import OutlinedButton from 'components/atoms/OutlinedButton';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import ContentsWrap from 'components/molecules/ContentsWrap';
import ChartButtonWrap from 'components/molecules/ChartButtonWrap';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const styles = (theme) => ({
  graph: {
    '& > h6': {
      fontSize: 16,
      margin: 0,
    },
  },
});

const graphList = [
  {
    title: i18next.t('ROAS'),
    data: {
      bar: ['PAR_CNT'],
      line: ['SESSION_ROAS', 'MONTH6_SESSION_ROAS', 'MONTH3_SESSION_ROAS'],
    },
    yAxisData: {
      left: { SESSION_ROAS: true, isPercent: true },
      right: { PAR_CNT: true },
    },
    customizeData: {
      SESSION_ROAS: {
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('CTR'),
    data: {
      bar: ['PAR_CNT'],
      line: ['CLICK_RATE', 'MONTH6_CLICK_RATE', 'MONTH3_CLICK_RATE'],
    },
    yAxisData: {
      left: { CLICK_RATE: true, rcent: true },
      right: { PAR_CNT: true },
    },
    customizeData: {
      CLICK_RATE: {
        isPercent: true,
      },
    },
  },
];

class MediaRoasStatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      curGraphComponent: {},
      infoMessage: '',
      loading: false,
      error: false,
    };
  }

  getData = () => {
    const { params, locale, t } = this.props;

    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });
    mediaRoasStatistics({
      ...paramConverter(params),
    })
      .then((response) => {
        const { data } = response.data;
        this.setState({
          ...this.state,
          //primitiveData: data.totDatas,
          primitiveData: data.totDatas,
          primitiveBData: data.bannerDatas,
          primitiveIData: data.icoverDatas,
          loading: false,
          error: false,
        });

        this.handleChangeGraph(graphList[0], 0)();
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  // /**
  //  * 새로고침
  //  */
  // handleRefesh = () => {
  //   this.getData();
  // };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    const { t } = this.props;
    const dateObj = moment(originalDate, 'YYYYMMDD');
    const month = twoDigits(dateObj.month() + 1);
    const year = twoDigits(dateObj.year());
    return onlyDay ? (
      `${t(month + '월')}`
    ) : (
      <span>
        {`${t(year + '년')}`}
        {`${t(month + '월')}`}
      </span>
    );
  };

  xAxisTick = (tickProps) => {
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dayStr = this.makeLabel(true)(value);

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={-8} dy={16} textAnchor="end" transform="rotate(-55)">
          {dayStr}
        </text>
      </g>
    );
  };

  /**
   * 버튼 클릭하여 그래프 데이터 변경
   * graphData json, index
   */
  handleChangeGraph =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      index
    ) =>
    (e) => {
      const { primitiveData, primitiveBData, primitiveIData } = this.state;

      if (typeof data !== 'undefined') {
        const { bar, line } = data;
        const dataKeys = {};
        const keyLabel = {};
        const tempGraphData = {};
        const tempGraphData_b = {};
        const tempGraphData_i = {};
        const graphData = [];
        const graphData_b = [];
        const graphData_i = [];
        let customizeData = {};
        const stackId = [];

        if (typeof bar !== 'undefined') {
          dataKeys['bar'] = bar;
        }

        if (typeof line !== 'undefined') {
          dataKeys['line'] = line;
        }

        if (typeof customize !== 'undefined') {
          customizeData = customize;
        }

        for (let kind in data) {
          if (data.hasOwnProperty(kind)) {
            const keys = data[kind];
            for (let i = 0; i < keys.length; i++) {
              const curKey = keys[i];
              if (kind === 'bar') {
                stackId.push(curKey);
              }

              keyLabel[curKey] = primitiveData[curKey].title;
              tempGraphData[curKey] = primitiveData[curKey].data;
            }
          }
        }

        // graph data 담는 곳
        for (let key in tempGraphData) {
          if (tempGraphData.hasOwnProperty(key)) {
            for (let i = 0; i < tempGraphData[key].length; i++) {
              const curGraphData = tempGraphData[key][i];
              let { name, val } = curGraphData;
              if (
                typeof customize !== 'undefined' &&
                typeof customize[key] !== 'undefined'
              ) {
                if (customize[key].isPercent) {
                  val *= 100;
                }
              }

              graphData[i] = {
                ...graphData[i],
                name,
                [key]: val,
              };
            }
          }
        }

        let tempChartTitle;
        const dataKeysValue = dataKeys['line'][0];
        if (dataKeysValue === 'SESSION_ROAS') {
          tempChartTitle = 'ROAS';
        } else if (dataKeysValue === 'CLICK_RATE') {
          tempChartTitle = 'CTR';
        }

        const result = (
          <>
            <MultiplexChart
              width="100%"
              xAxisTick={this.xAxisTick}
              makeLabel={this.makeLabel(false)}
              data={graphData}
              dataKeys={dataKeys}
              customizeData={customizeData}
              keyLabel={keyLabel}
              stackId={stackId.length !== 0 ? stackId.join('$') : null}
              yAxisData={yAxisData}
              legend
              title={'전체' + title}
              isPercent={isPercent}
              key={title}
            />
          </>
        );

        for (let kind in data) {
          if (data.hasOwnProperty(kind)) {
            const keys = data[kind];
            for (let i = 0; i < keys.length; i++) {
              const curKey = keys[i];
              if (kind === 'bar') {
                stackId.push(curKey);
              }

              keyLabel[curKey] = primitiveBData[curKey].title;
              tempGraphData_b[curKey] = primitiveBData[curKey].data;
            }
          }
        }

        // graph data 담는 곳
        for (let key in tempGraphData_b) {
          if (tempGraphData_b.hasOwnProperty(key)) {
            for (let i = 0; i < tempGraphData_b[key].length; i++) {
              const curGraphData = tempGraphData_b[key][i];
              let { name, val } = curGraphData;
              if (
                typeof customize !== 'undefined' &&
                typeof customize[key] !== 'undefined'
              ) {
                if (customize[key].isPercent) {
                  val *= 100;
                }
              }

              graphData_b[i] = {
                ...graphData_b[i],
                name,
                [key]: val,
              };
            }
          }
        }

        const result_banner = (
          <>
            <MultiplexChart
              width="100%"
              xAxisTick={this.xAxisTick}
              makeLabel={this.makeLabel(false)}
              data={graphData_b}
              dataKeys={dataKeys}
              customizeData={customizeData}
              keyLabel={keyLabel}
              stackId={stackId.length !== 0 ? stackId.join('$') : null}
              yAxisData={yAxisData}
              legend
              title={'배너' + title}
              isPercent={isPercent}
              key={title}
            />
          </>
        );

        for (let kind in data) {
          if (data.hasOwnProperty(kind)) {
            const keys = data[kind];
            for (let i = 0; i < keys.length; i++) {
              const curKey = keys[i];
              if (kind === 'bar') {
                stackId.push(curKey);
              }

              keyLabel[curKey] = primitiveIData[curKey].title;
              tempGraphData_i[curKey] = primitiveIData[curKey].data;
            }
          }
        }

        // graph data 담는 곳
        for (let key in tempGraphData_i) {
          if (tempGraphData_i.hasOwnProperty(key)) {
            for (let i = 0; i < tempGraphData_i[key].length; i++) {
              const curGraphData = tempGraphData_i[key][i];
              let { name, val } = curGraphData;
              if (
                typeof customize !== 'undefined' &&
                typeof customize[key] !== 'undefined'
              ) {
                if (customize[key].isPercent) {
                  val *= 100;
                }
              }

              graphData_i[i] = {
                ...graphData_i[i],
                name,
                [key]: val,
              };
            }
          }
        }

        const result_icover = (
          <>
            <MultiplexChart
              width="100%"
              xAxisTick={this.xAxisTick}
              makeLabel={this.makeLabel(false)}
              data={graphData_i}
              dataKeys={dataKeys}
              customizeData={customizeData}
              keyLabel={keyLabel}
              stackId={stackId.length !== 0 ? stackId.join('$') : null}
              yAxisData={yAxisData}
              legend
              title={'아이커버' + title}
              isPercent={isPercent}
              key={title}
            />
          </>
        );

        const { curGraphComponent } = this.state;
        curGraphComponent[0] = result;
        curGraphComponent[1] = result_banner;
        curGraphComponent[2] = result_icover;

        console.log(tempChartTitle);
        this.setState({
          ...this.state,
          curGraphComponent: curGraphComponent,
          selectedIdx: index,
          chartTitle: tempChartTitle,
        });
      }
    };

  render() {
    const { handleChangeGraph } = this;
    const { classes, t } = this.props;
    const {
      infoMessage,
      curGraphComponent,
      selectedIdx,
      primitiveData,
      loading,
      error,
    } = this.state;
    return (
      <SwitchingArea
        title={
          <>
            <InfoTitleArea
              title={t('데이터 그래프')}
              tooltipTitle={t(infoMessage)}
              iconType="fainfoCircle"
              iconColor={'graph'}
            />
          </>
        }
        // handleRefesh={handleRefesh}
      >
        {loading || error ? (
          <CurrentStatus type={loading ? 'loading' : error && 'error'} />
        ) : (
          <>
            <ChartButtonWrap>
              {graphList.map((item, index) => {
                return (
                  <OutlinedButton
                    key={item.title}
                    onClick={handleChangeGraph(item, index)}
                    selected={selectedIdx === index}
                    disabled={!Boolean(primitiveData)}
                  >
                    {item.title}
                  </OutlinedButton>
                );
              })}
            </ChartButtonWrap>
            <ContentsWrap contentsCount={1}>
              <div className={classes.graph}>
                <h6>전체 {this.state.chartTitle}</h6>
                {curGraphComponent[0]}
              </div>
              <div className={classes.graph}>
                <h6>배너 {this.state.chartTitle}</h6>
                {curGraphComponent[1]}
              </div>
              <div className={classes.graph}>
                <h6>아이커버 {this.state.chartTitle}</h6>
                {curGraphComponent[2]}
              </div>
            </ContentsWrap>
          </>
        )}
      </SwitchingArea>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withStyles(styles)(withTheme(MediaRoasStatisticsGraph)))
  )
);
